import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { onMounted, ref, watch } from "vue";
import { useBreakpoints } from "@/code/useBreakpoints";
import { useResizeObserver } from "@vueuse/core";


export default /*#__PURE__*/_defineComponent({
  __name: 'InspirationBlockWrapper',
  props: {
  numberOfTiles: {
    type: Number,
    required: true,
  },
  containerId: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;


const { isLg } = useBreakpoints();
const showAllButton = ref<boolean>(false);
const isShowingAll = ref<boolean>(false);
watch(isLg, (currValue) => {
  _toggleShowAllButton(currValue);
});
const showAll = () => {
  isShowingAll.value = true;
};
const showLess = () => {
  isShowingAll.value = false;
};
const toggleShowAll = () => {
  if (isShowingAll.value) {
    showLess();
  } else {
    showAll();
  }
};
useResizeObserver(document.querySelector("body"), () => {
  _calcHeight();
});
onMounted(() => {
  _toggleShowAllButton(isLg.value);
  _calcHeight();
});
const _toggleShowAllButton = (currValue) => {
  if (currValue) {
    showAllButton.value = props.numberOfTiles > 10;
  } else {
    showAllButton.value = props.numberOfTiles > 8;
  }
};
const _calcHeight = () => {
  const masonryContainerEl: HTMLElement | null = document.querySelector(`#${props.containerId}`);
  if (masonryContainerEl) {
    const showingEl = [...masonryContainerEl.children].find((x) => getComputedStyle(x).display != "none");
    if (showingEl) {
      const numberOfTilesToShow = isLg.value ? 2 : 4;
      const elements = [...showingEl.children].slice(0, numberOfTilesToShow);
      const height = elements.reduce((acc, currVal) => acc + currVal.clientHeight, 0);
      masonryContainerEl.style.maxHeight = `${height + 20 * numberOfTilesToShow - 18}px`;
    }
  }
};

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    isShowingAll: isShowingAll.value,
    showAllButton: showAllButton.value,
    toggleShowAll: toggleShowAll
  })
}
}

})